// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bundle-discount-section-label[data-v-0f49ae52]{display:flex;justify-content:space-between;margin-left:5px;margin-right:5px;position:relative;align-items:center}.bundle-discount-section-title[data-v-0f49ae52]{font-size:1rem;font-weight:700}", ""]);
// Exports
module.exports = exports;
